<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import Drawer from 'primevue/drawer'
import { useCommerceStore } from '~/stores/pos/commerce'

const { t } = useI18n()
const commerceStore = useCommerceStore()
const posCheckStore = usePosCheckStore()
const businessStore = useBusinessStore()

const {
  openCart,
} = storeToRefs(commerceStore)
const { hasActiveCheck } = storeToRefs(posCheckStore)
const { businessInfo } = storeToRefs(businessStore)

// Check if business uses restaurant (checks/tables) flow
const isChecksFlow = computed(() => businessInfo.value?.service_type === 'restaurant')
</script>

<template>
  <Drawer
    v-model:visible="openCart"
    position="right"
    pt:root:class="!w-[90%] md:!w-1/2"
    :header="isChecksFlow && !hasActiveCheck ? t('Tables') : hasActiveCheck ? t('Check Cart') : t('Cart')"
  >
    <!-- Checks-only flow: Show tables when no check, cart when active -->
    <template v-if="isChecksFlow">
      <POSCheckCart v-if="hasActiveCheck" />
      <POSTablesList v-else />
    </template>
    <!-- Orders flow: Show CheckCart when active, otherwise show regular cart -->
    <template v-else>
      <POSCheckCart v-if="hasActiveCheck" />
      <PublicStoreCart v-else />
    </template>
  </Drawer>
</template>
